import { render, staticRenderFns } from "./SpinnerColor.vue?vue&type=template&id=8caa9914&scoped=true"
import script from "./SpinnerColor.vue?vue&type=script&lang=js"
export * from "./SpinnerColor.vue?vue&type=script&lang=js"
import style0 from "./SpinnerColor.vue?vue&type=style&index=0&id=8caa9914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caa9914",
  null
  
)

export default component.exports